/* eslint-disable react/no-unused-prop-types */
import React, { Component, PropTypes } from 'react'
import classnames from 'classnames'
// import moment from 'moment'
import { format } from 'date-fns'
import Table from 'components/Table'
import Heading from 'components/Heading'
import Card from 'components/Card'
import CardFooter from 'components/CardFooter'
import Button from 'components/Button'
import constants from 'constants'

const styles = Object.assign(
  {},
  require('./AccountAndLoanList.scss'),
  { columns: require('../../columns.scss') },
  { table: require('components/Table/Table.scss') },
  { base: require('../../../../styles/base.scss') },
)

const headerStyles = classnames(styles.table.unSortable)

class AccountAndLoanList extends Component {
  static propTypes = {
    accountAndLoansItems: PropTypes.instanceOf(Array),
    accountsAndLoans: PropTypes.object,
    accountType: PropTypes.string.isRequired,
    bankTransferEnable: PropTypes.func,
    header: PropTypes.string,
    openBankTransferForm: PropTypes.func,
    selectedAccount: PropTypes.func.isRequired,
  }
  static defaultProps = {
    accountAndLoansItems: {},
    accountsAndLoans: null,
    openBankTransferForm: null,
    bankTransferEnable: null,
    header: '',
  }

  constructor(props) {
    super(props)
    this.state = {
      activeFilter: constants.ACCOUNTSANDLOANS.FILTER_TYPE.ACTIVE,
    }
  }

    //--- change the state value when the loan filter is toggled. This will trigger a re-render of component and display the relevant data based on the filter selected.
  handleLoanFilter = (loanTypeSelected) => {
    this.setState({ activeFilter: loanTypeSelected });
  }


   renderCols = () => {
    return (
      <tr>
        <th className={classnames(styles.columns.accountNo, headerStyles)}>
          Account No
        </th>
        <th className={classnames(styles.columns.legalName, headerStyles)}>
          Legal name
        </th>
        <th className={classnames(styles.columns.contractType, headerStyles)}>
          {this.props.accountType === constants.ACCOUNTSANDLOANS.ACCOUNT_TYPE.POST_SWIFT
            ? 'Contract'
            : 'Type'}
        </th>
        <th className={classnames(styles.columns.balance, headerStyles)}>
          Balance: {format(new Date(), constants.DATE_FORMAT.STANDARD_AU_FULLMONTH)}
        </th>
        <th className={classnames(styles.columns.view, headerStyles)}>View</th>
      </tr>
    )
  }

  renderData = () => {
    const isShortTermLoan = this.props.header === constants.ACCOUNTSANDLOANS.PRODUCT_TYPE.SHORT_TERM_LOAN_LABEL;
    const isActive = this.state.activeFilter === constants.ACCOUNTSANDLOANS.FILTER_TYPE.ACTIVE;

    return this.props.accountAndLoansItems.length ? (
      this.props.accountAndLoansItems.filter((acl) => {
        return isShortTermLoan ? true : (isActive ? acl.balance !== 0 : acl.balance === 0);
      }).map((acl, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <tr className={styles.base} key={`${acl.accountNo}-${i}`}>
          <td className={styles.nameCell}>{acl.accountNo}</td>
          <td className={styles.columns.legalName}>{acl.legalName}</td>
          <td>
            {this.props.accountType === constants.ACCOUNTSANDLOANS.ACCOUNT_TYPE.POST_SWIFT
              ? acl.contract
              : acl.type}
          </td>
          <td>{`${acl.balance.toLocaleString('en-AU', { style: 'currency', currency: 'AUD' })}`}</td>
          <td>
            <Button
              onClick={() => {
                this.props.selectedAccount({
                  AccountType: this.props.accountType,
                  AccountId: acl.accountId,
                  AccountNo: acl.accountNo,
                  LegalName: acl.legalName,
                })
              }}
              type="flat"
            >
              VIEW
            </Button>
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan={5}>
          <div className={styles.noAccountsAndLoans}>
            <div>No matching records found</div>
          </div>
        </td>
      </tr>
    )
  }


  render() {
    return (
      <div>
        <Heading noTopPadding>{this.props.header}</Heading>
        {this.props.header !== constants.ACCOUNTSANDLOANS.PRODUCT_TYPE.SHORT_TERM_LOAN_LABEL && (
          <div>
            <button 
              className={this.state.activeFilter === constants.ACCOUNTSANDLOANS.FILTER_TYPE.ACTIVE ? styles.base.tabActiveButton : styles.base.tabInactiveButton} 
              onClick={ () => this.handleLoanFilter(constants.ACCOUNTSANDLOANS.FILTER_TYPE.ACTIVE) }
            >
              Active
            </button>
            <button 
              className={this.state.activeFilter === constants.ACCOUNTSANDLOANS.FILTER_TYPE.EXTINGUISHED ? styles.base.tabActiveButton : styles.base.tabInactiveButton} 
              onClick={ () => this.handleLoanFilter(constants.ACCOUNTSANDLOANS.FILTER_TYPE.EXTINGUISHED) }
            >
              Extinguished
            </button>
          </div>
        )}
        <Card noPadding>
          <Table>
            <thead>{this.renderCols()}</thead>
            <tbody>{this.renderData()}</tbody>
          </Table>
          {this.props.bankTransferEnable &&
            this.props.accountAndLoansItems.length > 0 && (
              <CardFooter>
                <div className={styles.buttonContainer}>
                  <Button
                    onClick={this.props.openBankTransferForm}
                    style={{ marginLeft: 'auto' }}
                    type="flat"
                  >
                    REQUEST A TRANSFER
                  </Button>
                </div>
              </CardFooter>
            )}
        </Card>
      </div>
    )
  }
}

export default AccountAndLoanList



// WEBPACK FOOTER //
// ./src/views/AccountsAndLoans/components/AccountAndLoan/AccountAndLoanList.js